import { render, staticRenderFns } from "./DiscordIcon.vue?vue&type=template&id=8a64fc6a&functional=true"
import script from "./DiscordIcon.vue?vue&type=script&lang=js"
export * from "./DiscordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports